import React, { useState } from "react";
import { CiSearch } from "react-icons/ci";
import { FaArrowLeft } from "react-icons/fa";
import { MdKeyboardCommandKey } from "react-icons/md";
import searchResult from "../Data/SearchData";
import { IoTimeOutline } from "react-icons/io5";
export const MobileInputfield = ({ setShowSearchDropDown }) => {
  const [userSearch, setUserSearch] = useState("");
  const [dropDown, setDropDown] = useState(false);
  return (
    <div className="relative flex items-center space-x-4">
      <a href="/">

      <FaArrowLeft />
      </a>
      <div
        id="search_bar"
        className=" h-10 justify-between flex space-x-2 items-center bg-[#F2F2F2] dark:bg-[#1C1C1C] dark:text-white rounded-lg px-2 py-2 w-full"
      >
        <CiSearch className="text-2xl" />
        <input
          onChange={(e) => {
            setUserSearch(e.target.value.toLowerCase());
            setDropDown(!dropDown);
          }}
          className="bg-transparent text-black dark:text-white w-full italic outline-none"
          type="text"
          placeholder="Search ux flows, categories or screens"
        />
        <div
          onClick={() => setShowSearchDropDown(false)}
          className={
            userSearch.length > 0
              ? "cursor-pointer text-2xl rounded-lg p-1 px-3 flex items-center space-x-1"
              : "hidden"
          }
        >
          X
        </div>
        <div
          className={
            dropDown
              ? "absolute top-12 left-0 w-full rounded-b-xl bg-white dark:bg-[#3d3d3d] drop-shadow-lg h-auto p-4 z-[5000]"
              : "hidden"
          }
        >
          {searchResult
            .filter((a) => a.includes(userSearch))
            .map((result) => (
              <div className="flex items-center space-x-2">
                <IoTimeOutline />
                <p className="py-1">{result}</p>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};
